/**
 * **A sign-up waiting for its email link** (D51 row 8): when it was asked for, kept across tabs because the link opens
 * a new one, and nothing else. What BankID verified stays in the API's sealed cookie, never here.
 */
const EID_SIGN_UP = 'autho.eid.signUp';
const SIGN_UP_MS = 30 * 60_000;
export function eidSignUpWaiting(now = Date.now()): boolean {
  try {
    const at = Number(window.localStorage.getItem(EID_SIGN_UP));
    return at > 0 && now - at < SIGN_UP_MS;
  } catch {
    return false;
  }
}
export function clearEidSignUp() {
  try {
    window.localStorage.removeItem(EID_SIGN_UP);
  } catch {
    // Nothing to clear where storage is refused.
  }
}
export function markEidSignUp() {
  try {
    window.localStorage.setItem(EID_SIGN_UP, String(Date.now()));
  } catch {
    // A browser that refuses storage cannot finish here; the refusal after the link says so.
  }
}
